<fa-icon [icon]="$any(icon)" [fixedWidth]="fixedWidth" [rotate]="rotation" [class]="size" />
